import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getLogger } from '../../util/logger';
import bureaucrat from '../../util/Bureaucrat';
import { parseErrorMessage } from '../util/dataHelpers';

const logger = getLogger('CloudServiceEmail');

export const useCloudServiceEmailFormHandlers = (onComplete, onCancel) => {
  const [errorMsg, setErrorMsg] = useState('');
  const history = useHistory();

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  const handleSubmit = (values, actions) => {
    bureaucrat
      .confirmHybrid(values.cloudServiceEmail)
      .then((responseData) => {
        logger.debug(responseData);
        onComplete(responseData);
      })
      .catch((error) => {
        actions.setSubmitting(false);
        parseErrorMessage(error, setErrorMsg, history);
      });
  };

  return { handleSubmit, handleCancel, errorMsg };
};
